module.exports = __webpack_public_path__ + "static/tp-85b9356d4744b9a00de64a0e10fae5b9.mp4";